<template>

  <ul class="users">
    <li
      v-for="(user, index) in allUsers"
      :key="index"
      :style="{
        zIndex: users.length-index
      }"
      :class="{'master': user.master}"
      v-tooltip="user.name">
      <Avatar
        :src="user.photo_media_url && !user.photo_media_url.includes(defaultImageUrl) ? user.photo_media_url : null"
        :name="user.name"
        size="30px"
        radius="15px"
        resize="100x100x1" />
    </li>
  </ul>

</template>

<script>
import config from '@/config'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'RelatedUser',
  components: {
    Avatar
  },
  props: [
    'master',
    'users'
  ],
  data () {
    return {
    }
  },
  computed: {
    allUsers () {
      const arr = [
        ...(this.master ? [{...this.master, 'master': true}] : []),
        ...this.users
      ]
      return this.uniqueArr(arr, '_id')
    },
    defaultImageUrl () {
      return config.default_image_url.candidate
    }
  },
  created () {
  },
  methods: {
    uniqueArr (arr, key) {
      const unique = {}
      arr.forEach((v) => {
        unique[v[key]] = v
      })
      return Object.values(unique)
    }
    // use: stringToHslColor(user.name, 60, 55)
    /*
    stringToHslColor (str, s, l) {
      var hash = 0
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash)
      }

      var h = hash % 360
      return 'hsl(' + h + ', ' + s + '%, ' + l + '%)'
    }
    */
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.users{
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
}
  .users > li{
    margin-left: -7px;
  }
  .users > li:first-child{
    margin-left: 0;
  }
  .users > li.master{
  }
</style>



// WEBPACK FOOTER //
// src/components/Parts/RelatedUser.vue